export default __webpack_public_path__ + "static/media/right.e1e4319c.svg";